import { GroupParticipantType } from "../../Components/Group/TopGroupParticipantsSection/TopGroupParticipants.types";

export enum GroupTypeEnum {
    HOTEL = "HOTEL",
    HOLIDAY_HOME = "HOLIDAYHOME",
    CITY = "CITY",
    REGION = "REGION",
    COUNTRY = "COUNTRY",
    REGION_GROUP = "REGIONGROUP",
}

export type DomainGroupType = {
    activeBooking: boolean;
    activeBookingLabel: string | null;
    atLocation: boolean;
    atLocationCount: string;
    geoLat: number;
    geoLong: number;
    groupTypeWithParentName: string;
    guestsAtLocation: GroupParticipantType[];
    hasImages: boolean;
    hasRatings: boolean;
    id: number;
    isMember: boolean;
    isNotificationEnabled: boolean;
    parentId: string;
    parentName: string;
    postsCount: number;
    subline: string;
    title: string;
    type: GroupTypeEnum;
    image?: string;
    linkoutUrl?: string;
    parentPostsCount?: number;
    participants?: GroupParticipantType[];
};
